import "../../style/InternalPages.css";

function EleveQuestionnaire() {
  return (
    <div className="internal-page">
      <div className="internal-shell">
        <div className="internal-header">
          <p className="internal-eyebrow">Archive</p>
          <h1 className="internal-title">Questionnaires archives</h1>
          <p className="internal-subtitle">
            Cette partie a ete retiree de l&apos;interface active pour le
            moment, mais elle reste conservee dans le projet.
          </p>
        </div>
        <div className="internal-empty">
          La fonctionnalite questionnaire est archivee et n&apos;est plus
          proposee aux eleves dans la navigation.
        </div>
      </div>
    </div>
  );
}

export default EleveQuestionnaire;
